import React from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom"
import './rsbutton.css'
import editImg from "../../assets/img/link.png"
const ActionEditLink = ({to,onClick, children}) => {
  return (
    <Link
      to={to}
      className={`btn btn-edit`}
      onClick={onClick}
    >
     <img src={editImg} style={{width:30}} /> {children}
    </Link>
  );
};

ActionEditLink.propTypes = {
to:PropTypes.string,
onClick: PropTypes.func,
children: PropTypes.string,
};
ActionEditLink.defaultProps = {
    to:'#',
    onClick: () => {},
    children:''
  };
export default ActionEditLink;
